import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const bulkRemoveProductsFromBin = {
  name: "bulkRemoveProductsFromBin" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema).min(1),
    storageLocationIds: z.array(storageLocationIdFormat.schema).min(1),
  }),
  output: z.object({
    removedCount: z.number(),
    skippedNoAuthCount: z.number(),
    skippedNonZeroQuantity: z.array(
      z.object({
        productId: productIdFormat.schema,
        storageLocationId: storageLocationIdFormat.schema,
        quantity: z.number(),
      }),
    ),
  }),
};
